var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h2',{staticClass:"page-titles"},[_vm._v("Settings")]),(_vm.isTeamOwner)?[_c('transition',{attrs:{"name":"slide-fade"}},[_c(_vm.paigeSettings,{tag:"component"})],1)]:[(_vm.tabs[0].isActive)?_c(_vm.paigeSettings,{tag:"component"}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }